import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IProductRateRepository } from "./IProductRateRepository";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "src/app/models/SharedModels/response.model";
import { ProductRate } from "src/app/models/HR/ProductRate/product-rate";

@Injectable(
    {
        providedIn: "root"
    }
)

export class ProductRateRepository extends GenericRepository<ProductRate> implements IProductRateRepository {
    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/PetrolRate', environment.urlAddress);
    } 

    LoadNavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        return this.GetById('NavRec/' + navType + '/' + currentIndex).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadRec(code: string): Observable<ResponseModel> {
        debugger
        return this.GetById('GetRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
    DeleteRec(code: string) {
        return this._http.delete(this.url + `api/PetrolRate/DeleteRec/${code}`)
        .pipe(map(this.extractData), catchError(this.handleError));
    } 
    GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
        filterText = filterText.split('/').join('~');
        if (filterText == "") {
            filterText = "|";
        }
        return this._http
            .get(this.url + 'api/PetrolRate/SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

    
    SaveRec(): Observable<ResponseModel> {
        return this.PostData('/SaveRec', null).pipe(map(this.extractData), catchError(this.handleError));
    }
    
}
